import React from 'react';
import PropTypes from 'prop-types';
import EmptyState from 'Components/EmptyState/EmptyState';
import GDTableSummaryHorizontalPanel from '../GDTable/GDTableSummaryHorizontalPanel/GDTableSummaryHorizontalPanel';
import counterpart from 'counterpart';
import './ImageSearchResults.scss';

const ImageSearchResults = (props) => {
  if (props.selectAllFlag)
    props.summaryPanel[0].name = `Assign All Pages`;
  else {
    if (props.summaryPanel[0].displayType && props.selectedPages.length === 1) {
      props.summaryPanel[0].name = `Assign ${props.selectedPages.length} Page`;
    } else if (props.summaryPanel[0].displayType && props.selectedPages.length > 1) {
      props.summaryPanel[0].name = `Assign ${props.selectedPages.length} Pages`;
    } else {
      props.summaryPanel[0].name = `Assign All Pages`;
    }
  }
  return (
    <div className="image-search-results">
      <div className="assignment-title" style={{marginTop: props.isAssignPages && props.summaryData.some(row=>row.clear==false) && '-15px', marginBottom: props.isAssignPages && props.summaryData.some(row=>row.clear==false) && '-10px'}}>Search Results</div>
      {(props.searchContent === undefined || (props.searchContent !== undefined && props.searchContent.length === 0)) && (
        <EmptyState
          translations={{ emptyStateHeading: counterpart('globalTranslate.queues.emptyStateHeading'), emptyStateDescription: counterpart('globalTranslate.queues.emptyStateDescription') }}
        />
      )}


      {props.searchContent !== undefined && props.searchContent.length > 0 && (
        <GDTableSummaryHorizontalPanel
          type={props.type}
          summaryData={props.summaryData}
          summaryFields={props.searchPanel}
          summaryPanel={props.summaryPanel}
          summaryContent={props.searchContent}
          selectedPages={props.selectedPages}
          actionMethod={props.attachSelectedCase}
          pageList={props.pageList}
          setSummaryData={props.setSummaryData}
          goToCaseLandingPageByCaseNumber={props.goToCaseLandingPageByCaseNumber}
          dateFormat={props.dateFormat}
          currentImageIndex={props.currentImageIndex}
          isAttachStarted={props.isAttachStarted}
          user={props.user}
          isMerchantPortal={props.isMerchantPortal}
          currentSelectedImageIndex={props.currentSelectedImageIndex}
        />
      )}
      <div className="fade" />
    </div>
  );
};


ImageSearchResults.propTypes = {
  title: PropTypes.string,
  searchPanel: PropTypes.array,
  summaryPanel: PropTypes.array,
  searchContent: PropTypes.array,
  attachSelectedCase: PropTypes.func,
  currentImageIndex: PropTypes.func,
  selectedPages: PropTypes.array,
  dateFormat: PropTypes.string,
  isMerchantPortal: PropTypes.bool,
  goToCaseLandingPageByCaseNumber: PropTypes.func,
  currentSelectedImageIndex: PropTypes.number
};

ImageSearchResults.defaultProps = {
  title: '',
  searchPanel: {},
  summaryPanel: {},
  searchContent: [],
  attachSelectedCase: () => { },
  currentImageIndex: () => { },
  goToCaseLandingPageByCaseNumber: () => { },
  dateFormat: '',
  selectedPages: 0,

};

export default ImageSearchResults;
